<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout wrap>
            <v-flex xs12 class="pt-0">
                <material-card color="green" :title="callsTitle">
                    <div class="mb-2 calls-toolbar">
                        <div class="calls-filters">
                            <v-text-field
                                v-model="nameFilter"
                                placeholder="Name / caller..."
                                prepend-icon="mdi-magnify"
                                clearable
                                hide-details
                                class="calls-filter-input"
                            ></v-text-field>
                            <v-menu
                                v-model="fromDateMenu"
                                :close-on-content-click="false"
                                offset-y
                                max-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="fromDateFilter"
                                        placeholder="From date"
                                        prepend-icon="mdi-calendar"
                                        clearable
                                        hide-details
                                        readonly
                                        class="calls-filter-input"
                                        v-on="on"
                                        @click:clear="fromDateFilter = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="fromDateFilter"
                                    no-title
                                    @input="fromDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                            <v-menu
                                v-model="toDateMenu"
                                :close-on-content-click="false"
                                offset-y
                                max-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="toDateFilter"
                                        placeholder="To date"
                                        prepend-icon="mdi-calendar"
                                        clearable
                                        hide-details
                                        readonly
                                        class="calls-filter-input"
                                        v-on="on"
                                        @click:clear="toDateFilter = null"
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="toDateFilter"
                                    no-title
                                    @input="toDateMenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </div>
                        <div class="calls-toolbar-right">
                            <span class="calls-count">
                                {{ filteredCallDetails.length }}
                                <template v-if="filteredCallDetails.length !== callDetails.length"> / {{ callDetails.length }}</template>
                                calls
                            </span>
                            <span
                                v-if="!isUsingFallbackData && firebaseLoaded"
                                style="font-weight: 600; color: #4caf50; font-size: 14px;"
                            >
                                ● Firebase
                            </span>
                            <span
                                v-else-if="isUsingFallbackData"
                                style="font-weight: 600; color: #ff9800; font-size: 14px;"
                            >
                                ● Fallback
                            </span>
                            <v-btn small color="success" dark @click="refreshCalls">
                                Refresh
                            </v-btn>
                        </div>
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="filteredCallDetails"
                        v-bind:pagination.sync="pagination"
                        hide-actions
                        disable-initial-sort
                    >
                        <template slot="headerCell" slot-scope="{ header }">
                            <span
                                class="font-weight-light text-success text--darken-3"
                                v-text="header.text"
                            />
                        </template>
                        <template slot="items" slot-scope="{ index, item }">
                            <tr
                                @click="viewDetails(item)"
                                style="cursor: pointer;"
                            >
                                <td>
                                    <v-tooltip top dark>
                                        <template #activator="{ on }" dark>
                                            <v-icon
                                                v-on="on"
                                                dark
                                                :color="
                                                    getStatusIcon(item).color
                                                "
                                                >{{
                                                    getStatusIcon(item).icon
                                                }}</v-icon
                                            >
                                        </template>
                                        <span dark>{{ item.Status }}</span>
                                    </v-tooltip>
                                </td>
                                <td class="font-weight-regular">
                                    {{ item.Name }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ item.CallerID }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ formatTime(item.Timestamp) }}
                                </td>
                                <td class="text-xs-left font-weight-regular">
                                    {{ getCallDuration(item) }}
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                    <div class="text-xs-center mt-2">
                        <v-pagination
                            v-model="pagination.page"
                            :length="pages"
                            :total-visible="5"
                        ></v-pagination>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="viewCallDialog" max-width="750">
            <v-card class="p-2">
                <v-card-title class="headline">Call Activity</v-card-title>
                <v-card-text class="mb-3">
                    <v-layout row>
                        <div>
                            <div class="font-weight-medium mb-2">
                                {{
                                    clickedCall.Name
                                        ? clickedCall.Name
                                        : clickedCall.CallerID
                                }}
                            </div>
                        </div>
                        <v-spacer></v-spacer>
                        <div>
                            <v-layout row class="mb-2">
                                <div class="font-weight-medium mr-2">
                                    Call Time:
                                </div>
                                <div>
                                    {{ formatTime(clickedCall.Timestamp) }}
                                </div>
                            </v-layout>
                        </div>
                    </v-layout>
                </v-card-text>
                <v-list>
                    <div v-for="(action, index) in clickedCall.Logs">
                        <v-list-tile
                            class="row-height"
                            v-bind:class="{
                                'mt-3': action.RecordingURL,
                                'mb-4': action.RecordingURL,
                            }"
                        >
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    formatTime(action.Timestamp)
                                }}</v-list-tile-title>
                            </v-list-tile-content>
                            <v-spacer></v-spacer>
                            <v-list-tile-action style="height: 90px;">
                                <v-list-tile-title
                                    class="text-xs-right mt-1"
                                    v-bind:class="{
                                        'pt-3 pb-4': !action.RecordingURL,
                                    }"
                                    >{{ action.Description }}
                                </v-list-tile-title>
                                <audio
                                    style="height: 33px;"
                                    v-if="action.RecordingURL"
                                    class="mt-2"
                                    controls
                                    :src="action.RecordingURL"
                                    ref="recording"
                                ></audio>
                                <div class="progress mt-2">
                                    <span
                                        id="progress-amount"
                                        v-if="action.RecordingURL"
                                        ref="recordingProgress"
                                    ></span>
                                </div>
                            </v-list-tile-action>
                        </v-list-tile>
                        <div v-if="action.Data" class="body-2 ml-3 mb-2">
                            {{ action.Data }}
                        </div>
                        <v-divider
                            v-if="index + 1 < clickedCall.Logs.length"
                        ></v-divider>
                    </div>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        class="mb-2"
                        @click="viewCallDialog = false"
                        color="#999"
                        dark
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ky from "ky";
import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import moment from "moment";

const FALLBACK_ODATA_DOMAIN = "https://wercbergerproductions-app-164903695581.us-east1.run.app";

export default {
    data() {
        return {
            rowsPerPageItems: [10, 20],
            pagination: {
                totalItems: 0,
                rowsPerPage: 20,
                page: 1,
            },

            headers: [
                { value: "Status", text: "Status" },
                { value: "Name", text: "Caller" },
                { value: "CallerID", text: "Caller ID" },
                { value: "Timestamp", text: "Time" },
                { value: "duration", text: "Duration" },
                // { value: "HangupCauseName", text: "Hangup Cause" }
            ],

            calls: [],
            callDetails: [],
            nameFilter: "",
            fromDateFilter: null,
            toDateFilter: null,
            fromDateMenu: false,
            toDateMenu: false,
            fallbackCallsLoading: false,
            isUsingFallbackData: false,
            firebaseLoaded: false,
            firebaseLoadTimerId: null,
            fallbackReloadIntervalId: null,
            accountInfo: null,

            clickedCall: "",
            viewCallDialog: false,
        };
    },
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.filteredCallDetails.length / this.pagination.rowsPerPage,
                  )
                : 0;
        },
        filteredCallDetails() {
            return this.callDetails.filter((call) => {
                if (this.nameFilter && this.nameFilter.trim()) {
                    const search = this.nameFilter.trim().toLowerCase();
                    const nameMatch =
                        (call.Name && call.Name.toLowerCase().includes(search)) ||
                        (call.CallerID && call.CallerID.toLowerCase().includes(search));
                    if (!nameMatch) return false;
                }

                if (this.fromDateFilter && call.Timestamp) {
                    const callDate = call.Timestamp.substring(0, 10);
                    if (callDate < this.fromDateFilter) return false;
                }

                if (this.toDateFilter && call.Timestamp) {
                    const callDate = call.Timestamp.substring(0, 10);
                    if (callDate > this.toDateFilter) return false;
                }

                return true;
            });
        },
        callsTitle() {
            if (!this.accountInfo) {
                return "P Calls";
            }

            const plivoCredit =
                typeof this.accountInfo.credit === "number"
                    ? this.accountInfo.credit.toFixed(2)
                    : "0.00";
            const twilioCredit =
                typeof this.accountInfo.twilioCredit === "number"
                    ? this.accountInfo.twilioCredit.toFixed(2)
                    : "0.00";

            return `P Calls - Plivo: $${plivoCredit} | Twilio: $${twilioCredit}`;
        },
    },
    filters: {
        pretty: function(value) {
            if (!value) return "";

            return JSON.stringify(value, null, 2);
        },
    },
    created() {
        this.loadData();
        this.loadAccountInfo();
        this.firebaseSetup();
        this.startFallbackAutoRefresh();
    },
    mounted() {
        //this.intervalID = window.setInterval(this.loadLastCalls, 60000);
    },
    beforeDestroy() {
        //window.clearInterval(this.intervalID);
        if (this.firebaseLoadTimerId) {
            clearTimeout(this.firebaseLoadTimerId);
            this.firebaseLoadTimerId = null;
        }

        if (this.fallbackReloadIntervalId) {
            clearInterval(this.fallbackReloadIntervalId);
            this.fallbackReloadIntervalId = null;
        }
    },
    methods: {
        // async loadLastCalls() {
        //     const calls = await ky("api/home/getLastCalls", {
        //         prefixUrl: this.getDomain()
        //     }).json();

        //     calls.forEach(c => this.calls.push(c));

        //     this.callDetails.forEach(cd => {
        //         const call = this.calls.find(c => c.callUUID == cd.Call_UUID);
        //         if (call) {
        //             cd.duration = call.callDuration;
        //         }
        //     });
        // },
        async loadData() {},
        async loadAccountInfo() {
            try {
                const response = await ky("api/broadcast/GetAccountInfo", {
                    prefixUrl: FALLBACK_ODATA_DOMAIN,
                }).json();
                this.accountInfo = response || null;
            } catch (error) {
                console.log("GetAccountInfo error", error);
            }
        },
        applyCallDetails(callDetails, isFallback) {
            this.callDetails = callDetails.sort((a, b) => {
                if (
                    this.getTimestampValue(a.Timestamp) >
                    this.getTimestampValue(b.Timestamp)
                )
                    return -1;
                if (
                    this.getTimestampValue(a.Timestamp) <
                    this.getTimestampValue(b.Timestamp)
                )
                    return 1;
                return 0;
            });

            this.pagination.totalItems = this.callDetails.length;
            this.isUsingFallbackData = isFallback;
        },
        normalizeCall(call) {
            const callDuration = parseInt(
                call.Duration || call.duration,
                10,
            );
            const duration = isNaN(callDuration) ? 0 : callDuration;

            // Support both PascalCase (old Firebase) and camelCase (new Firebase)
            const callerId =
                call.CallerID || call.CallerId || call.callerID || call.callerId || "";
            const timestamp =
                call.Timestamp || call.timestamp || "";
            const name = call.Name || call.name || "";
            const callUuid =
                call.CallUuid || call.callUuid || call.callUUID || "";

            // Logs can be a Firebase RTDB object (keyed) or an array
            let logs = [];
            if (Array.isArray(call.Logs)) {
                logs = call.Logs;
            } else if (Array.isArray(call.logs)) {
                logs = call.logs;
            } else if (call.Logs && typeof call.Logs === "object") {
                logs = Object.values(call.Logs).map(this.normalizeLog);
            } else if (call.logs && typeof call.logs === "object") {
                logs = Object.values(call.logs).map(this.normalizeLog);
            }

            logs = logs.sort((a, b) =>
                this.getTimestampValue(a.Timestamp) -
                    this.getTimestampValue(b.Timestamp),
            );

            const endTime =
                call.EndTime ||
                call.endTime ||
                (logs.length ? logs[logs.length - 1].Timestamp : timestamp);

            return Object.assign({}, call, {
                duration,
                Duration: duration,
                CallerID: this.formatPhoneNumber(callerId) || callerId,
                Name: name,
                Timestamp: timestamp,
                Logs: logs,
                EndTime: endTime,
                CallUuid: callUuid,
            });
        },
        normalizeLog(log) {
            return {
                Timestamp: log.Timestamp || log.timestamp || "",
                Description: log.Description || log.description || "",
                Data: log.Data || log.data || "",
                RecordingURL: log.RecordingURL || log.recordingURL || log.recordingUrl || "",
                Event: log.Event || log.event || "",
                Author: log.Author || log.author || "",
                CallUuid: log.CallUuid || log.callUuid || "",
            };
        },
        mapFallbackLog(log) {
            return {
                Id: log.id,
                Timestamp: log.timesamp || log.timestamp,
                Description: log.description,
                Data: log.data,
                RecordingURL: log.recordingUrl,
                Event: log.event,
                Author: log.author,
                CallUuid: log.callUuid,
            };
        },
        async loadFallbackCallLogs(callUuid) {
            if (!callUuid) {
                return [];
            }

            try {
                const response = await ky("api/calls/GetCallLogs", {
                    prefixUrl: FALLBACK_ODATA_DOMAIN,
                    searchParams: {
                        callUuid: callUuid,
                    },
                }).json();

                const logs = Array.isArray(response)
                    ? response
                    : Array.isArray(response.value)
                      ? response.value
                      : [];

                return logs
                    .map((log) => this.mapFallbackLog(log))
                    .sort((a, b) => {
                        if (
                            this.getTimestampValue(a.Timestamp) >
                            this.getTimestampValue(b.Timestamp)
                        )
                            return 1;
                        if (
                            this.getTimestampValue(a.Timestamp) <
                            this.getTimestampValue(b.Timestamp)
                        )
                            return -1;
                        return 0;
                    });
            } catch (error) {
                console.log("Fallback getCallLogs error", error);
                return [];
            }
        },
        async loadCallsFromFallback() {
            if (this.fallbackCallsLoading) {
                return;
            }

            this.fallbackCallsLoading = true;

            try {
                const response = await ky("odata/calls", {
                    prefixUrl: FALLBACK_ODATA_DOMAIN,
                    searchParams: {
                        $orderby: "Timestamp desc",
                        $top: "300",
                    },
                }).json();

                const calls = Array.isArray(response)
                    ? response
                    : Array.isArray(response.value)
                      ? response.value
                      : [];

                const normalizedCalls = calls.map((call) =>
                    this.normalizeCall(call),
                );

                this.applyCallDetails(normalizedCalls, true);
            } catch (error) {
                console.log("Fallback odata/calls error", error);
            } finally {
                this.fallbackCallsLoading = false;
            }
        },
        startFallbackAutoRefresh() {
            if (this.fallbackReloadIntervalId) {
                clearInterval(this.fallbackReloadIntervalId);
            }

            this.fallbackReloadIntervalId = setInterval(async () => {
                if (this.isUsingFallbackData) {
                    await this.loadCallsFromFallback();
                }
            }, 10 * 60 * 1000);
        },
        async refreshCalls() {
            if (this.isUsingFallbackData) {
                await this.loadCallsFromFallback();
            }
            await this.loadAccountInfo();
        },
        scheduleFirebaseFallback() {
            if (this.firebaseLoadTimerId) {
                clearTimeout(this.firebaseLoadTimerId);
            }

            this.firebaseLoadTimerId = setTimeout(() => {
                if (!this.firebaseLoaded) {
                    this.loadCallsFromFallback();
                }
            }, 5000);
        },
        async firebaseSetup() {
            try {
                const firebaseConfig = {
                    apiKey: "AIzaSyBpUbGDkNcuQCWZAhDN_Jzv5HnDCx5ILzE",
                    authDomain: "gopro-computers.firebaseapp.com",
                    databaseURL: "https://gopro-computers-default-rtdb.firebaseio.com",
                    projectId: "gopro-computers",
                    storageBucket: "gopro-computers.firebasestorage.app",
                    messagingSenderId: "166746935956",
                    appId: "1:166746935956:web:851de7394c655f22469a81",
                };

                // Use a named app instance so it doesn't conflict with other Firebase apps
                const existingApp = firebase.apps.find(
                    (a) => a.name === "gopro-computers",
                );
                const app =
                    existingApp ||
                    firebase.initializeApp(firebaseConfig, "gopro-computers");

                // Sign in anonymously so DB rules (auth != null) are satisfied
                if (!app.auth().currentUser) {
                    await app.auth().signInAnonymously();
                }

                this.scheduleFirebaseFallback();

                var ref = app.database().ref("private_calls");
                const callsRef = ref.orderByKey().limitToLast(400);

                callsRef.on(
                    "value",
                    (snapshot) => {
                        try {
                            this.firebaseLoaded = true;

                            if (this.firebaseLoadTimerId) {
                                clearTimeout(this.firebaseLoadTimerId);
                                this.firebaseLoadTimerId = null;
                            }

                            const snapshotValue = snapshot.val() || {};
                            const callDetails = Object.values(snapshotValue).map(
                                (call) => this.normalizeCall(call),
                            );
                            this.applyCallDetails(callDetails, false);
                        } catch (error) {
                            console.log("Firebase value handler error", error);
                            this.loadCallsFromFallback();
                        }
                    },
                    (error) => {
                        console.log("Error: " + error.code);
                        this.loadCallsFromFallback();
                    },
                );
            } catch (error) {
                console.log("Firebase setup error", error);
                this.loadCallsFromFallback();
            }
        },
        getCallDuration(item) {
            if (item.duration > 0)
                return moment("2015-01-01")
                    .startOf("day")
                    .seconds(item.duration)
                    .format("mm:ss");

            if (
                !item.Logs ||
                !item.Logs.length ||
                !item.Timestamp ||
                !item.EndTime
            ) {
                return "00:00";
            }

            const endTime = item.EndTime;

            const duration = moment.duration(
                moment(endTime).diff(moment(item.Timestamp)),
            );

            return moment.utc(duration.as("milliseconds")).format("mm:ss");
        },
        getStatusIcon(item) {
            if (item.duration) {
                return {
                    icon: "mdi-check-circle",
                    color: "success",
                };
            }

            return {
                icon: "mdi-clock",
                color: "#fdb400",
            };
        },
        getDomain() {
            return window.location.origin.startsWith("http://localhost:8081") ||
                window.location.origin.startsWith("http://localhost:8080")
                ? "https://localhost:44337"
                : window.location.origin;
        },
        formatTime(date) {
            return moment(date).format("MM/DD/YYYY h:mm:ss A");
        },
        getTimestampValue(timestamp) {
            if (timestamp === null || timestamp === undefined || timestamp === "") {
                return 0;
            }

            if (typeof timestamp === "number") {
                return timestamp;
            }

            const numericTimestamp = Number(timestamp);
            if (!isNaN(numericTimestamp) && String(timestamp).trim() !== "") {
                return numericTimestamp;
            }

            const parsedTimestamp = Date.parse(timestamp);
            return isNaN(parsedTimestamp) ? 0 : parsedTimestamp;
        },
        formatPhoneNumber(phoneNumberString) {
            if (phoneNumberString.length > 10) return phoneNumberString;

            var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
            if (match) {
                return "(" + match[1] + ") " + match[2] + "-" + match[3];
            }
            return null;
        },
        getPlaybackSeconds(index) {
            const logs = this.clickedCall.Logs.filter((l) => l.RecordingURL);

            const event1 = logs[index];
            const originalIndex = this.clickedCall.Logs.indexOf(event1);

            let event2 = "";

            if (this.clickedCall.Logs.length == originalIndex + 1) {
                event2 = { Timestamp: this.clickedCall.EndTime };
            } else {
                event2 = logs[index + 1];
            }

            const duration = moment.duration(
                moment(event2.Timestamp).diff(moment(event1.Timestamp)),
            );

            return duration.asSeconds();
        },
        closeCallDetails() {
            this.viewCallDialog = false;
            this.clickedCall = "";
        },
        async viewDetails(item) {
            if (!item.Logs) {
                item.Logs = [];
            }

            const callUuid = item.CallUuid || item.callUuid;
            const shouldLoadFallbackLogs =
                this.isUsingFallbackData && !item.Logs.length && callUuid;

            if (shouldLoadFallbackLogs) {
                item.Logs = await this.loadFallbackCallLogs(callUuid);
            }

            item.EndTime = item.EndTime
                ? item.EndTime
                : item.Logs.length
                  ? item.Logs[item.Logs.length - 1].Timestamp
                  : item.Timestamp;

            this.clickedCall = item;

            console.log(item);

            //console.log(JSON.stringify(this.clickedCall, null, 2));

            this.viewCallDialog = true;

            setTimeout(this.setPlaybackTime, 0);
        },
        setPlaybackTime() {
            this.clickedCall.Logs.filter((l) => l.RecordingURL).forEach(
                (log, index) => {
                    if (!this.$refs.recording || !this.$refs.recording[index])
                        return;

                    this.$refs.recording[
                        index
                    ].currentTime = this.getPlaybackSeconds(index);

                    this.addProgressEvent(this.$refs.recording[index], index);
                },
            );
        },
        addProgressEvent(myAudio, index) {
            myAudio.addEventListener("timeupdate", (e) =>
                this.updateProgress(e, index),
            );
        },
        updateProgress(e, index) {
            const duration = this.$refs.recording[index].duration;

            if (duration > 0) {
                this.$refs.recordingProgress[index].style.width =
                    (this.$refs.recording[index].currentTime / duration) * 100 +
                    "%";
            }
        },
    },
};
</script>
<style>
tbody tr:nth-child(even) {
    background-color: #eee;
}

.row-height.v-list__tile theme--light {
    min-height: 75px !important;
    height: 75px !important;
}
.progress {
    margin-top: -20px;
    height: 5px;
    position: relative;
    width: 300px;
}

#progress-amount {
    display: block;
    height: 100%;
    background-color: #5cb860;
    width: 0;
}

.calls-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
}

.calls-filters {
    display: flex;
    align-items: center;
    gap: 16px;
    flex-wrap: wrap;
}

.calls-toolbar-right {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.calls-count {
    font-size: 13px;
    font-weight: 600;
    color: #555;
    white-space: nowrap;
}

.calls-filter-input {
    max-width: 180px;
    padding-top: 0 !important;
    margin-top: 0 !important;
}

.calls-filter-input .v-input__control {
    min-height: 32px !important;
}

.calls-filter-input .v-text-field__slot input {
    padding: 4px 0 4px !important;
    font-size: 14px;
}

.v-date-picker-table .v-btn {
    color: rgba(0, 0, 0, 0.87) !important;
}
</style>
